import { useCallback, useState } from 'react';
import { DEFAULT_TRANSPORT_METHOD } from 'appConstants';
import type { IOrderProduct, IProductDeliveryDetails } from 'contexts/Orders';

import OrderWizardContext from './OrderWizardContext';

const initialDeliveryDetails = {
  addressNumber: null,
  transportMethod: DEFAULT_TRANSPORT_METHOD,
  startDate: '',
  endDate: '',
  packagedItemNotes: '',
  addressData: {},
};

export default function OrderWizardProvider({ children }) {
  const [lastDeliveryDetails, setLastDeliveryDetails] =
    useState<IProductDeliveryDetails>(initialDeliveryDetails);

  const updateLastDeliveryDetails = useCallback(
    ({
      addressNumber,
      transportMethod,
      startDate,
      endDate,
      packagedItemNotes,
      addressData,
    }: IOrderProduct) => {
      setLastDeliveryDetails({
        addressNumber,
        transportMethod,
        startDate,
        endDate,
        packagedItemNotes,
        addressData,
      });
    },
    [setLastDeliveryDetails],
  );

  const resetDeliveryDetails = useCallback(() => {
    setLastDeliveryDetails(initialDeliveryDetails);
  }, [setLastDeliveryDetails]);

  return (
    <OrderWizardContext.Provider
      value={{
        lastDeliveryDetails,
        updateLastDeliveryDetails,
        resetDeliveryDetails,
      }}
    >
      {children}
    </OrderWizardContext.Provider>
  );
}
